import React from "react";
import { getCompanyApi } from '../../../../services/companiesApi';

export default class AutoCompleteText extends React.Component {
    constructor(props) {
        super(props)
        this.items = []

        this.state = {
            suggestions: props.suggestions,
            company: props.company
        }
    }

    onTextChange = async (e) => {
        const value = e.target.value
        await this.setState({company: value})
        this.props.setCompany(value)
        if(value !== ''){
            getCompanyApi(this.state.company)
                .then(res => res.json())
                .then(data => this.setState({suggestions: data}))
        }
    }

    clearItems = (e) => {
        const company = e.currentTarget.dataset.id
        this.setState({company })
        this.props.setCompany(company)
        this.setState({suggestions: [] })
    }

    renderSuggestion = () => {
        const {suggestions} = this.state
        if(suggestions.length === 0) {
            return null
        }

        return (
            <ul>{suggestions.map((item) => <li key={item} onClick={this.clearItems.bind(this)} data-id={item}>{item}</li>)}</ul>
        )
    }

    render() {
       return (
           <div className={`AutoCompleteText`}>
                <input value={this.state.company} onChange={this.onTextChange} type="text"/>
                {this.renderSuggestion()}
            </div>
       )
    }
}
